export enum UserPlanSubscription {
	AdHoc = 'AdHoc',
	Demo = 'Demo',
	Retainer = 'Retainer',
}
